module.exports = __webpack_public_path__ + "img/chat.c6c43fee.svg";